import { Col, Row, Modal, Form, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { useState, useEffect, Dispatch } from "react";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { PaymentModeType } from "./paymentType";
import { createpaymentModes, editpaymentModes } from "../../../api/paymentMode";
import Title from "../../UI/Title/Title";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { AxiosResponse } from "axios";
import InputName from "../../UI/InputNumberComponent/InputName";

type propsType = {
  id?: string | number;
  openPayment: boolean;
  Payment?: PaymentModeType | undefined;
  setOpenPayment: React.Dispatch<React.SetStateAction<boolean>>;
  filter: boolean | undefined;
  search: any;
  page: number;
  PaymentModeMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
  setPaginatedPaymentMode: Dispatch<any>;
};

export const AddEditPayment = ({
  openPayment,
  setOpenPayment,
  Payment,
  id,
  search,
  page,
  filter,
  setPaginatedPaymentMode,
  PaymentModeMutation,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const isEdit = () => {
    return !!id;
  };
  const [isActive, setIsActive] = useState<boolean>(
    Payment ? Payment?.isActive : true
  );
  const onError = (
    error: any,
    variables: PaymentModeType,
    context: unknown
  ) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutate: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createpaymentModes" : "editpaymentModes",
    !isEdit()
      ? (payment: PaymentModeType) => createpaymentModes(payment)
      : (payment: PaymentModeType) => editpaymentModes(id, payment),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenPayment(false);
        message.success("Complete successfully");
        PaymentModeMutation({
          limit: page * 8 + 8,
          q: search,
          isActive: filter,
        }).then((res) => {
          setPaginatedPaymentMode(res.data);
        });
      },
      onError,
    }
  );
  const handleFinish = () => {
    const newPayment = form.getFieldsValue();
    for (const key in newPayment) {
      if (newPayment[key] === undefined) {
        if (key === "isActive") {
          newPayment[key] = true;
        } else {
          newPayment[key] = null;
        }
      } else if (
        typeof newPayment[key] === "string" &&
        newPayment[key].trim() === ""
      ) {
        newPayment[key] = null;
      }
    }
    mutateCreateUpdate(newPayment);
  };

  const [inputName, setInputName] = useState(false);

  const [editStatus] = useState(isEdit());
  useEffect(() => {
    if (editStatus) {
      setInputName(true);
    }
  }, [editStatus]);
  const handleInputChange = (value: any) => {
    setInputName(value);
  };
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        width={490}
        centered
        onCancel={() => setOpenPayment(false)}
        open={openPayment}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !inputName,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={isEdit() ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title
          title={
            isEdit()
              ? `${t("edit-payment-method")}`
              : `${t("add-payment-method")}`
          }
        />
        {isEdit() && (
          <span className="modaltitleEdit">
            {t("edit-details-for")} {Payment?.mode}
          </span>
        )}
        <Form
          data-testid="form"
          layout="vertical"
          form={form}
          id="paymentForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col span={14} style={{ marginTop: "20px" }}>
              <Form.Item
                initialValue={Payment?.mode}
                name="mode"
                label={t("payment-method")}
                rules={[
                  {
                    required: true,
                    message: "payment method is required",
                  },
                ]}
              >
                <InputName
                  maxLength={50}
                  data-testid="name"
                  onChange={handleInputChange}
                />
              </Form.Item>

              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="paymentForm"
        open={open}
        setOpen={setOpen}
        name={<span>{Payment?.mode}</span>}
        title={`${t("modal-payment")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
